import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductResponse } from '../models/producto.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface ProductoDrawerOptions {
  productoId?: number;
  prefilledCategoryId?: number;
}

@Injectable({ providedIn: 'root' })
export class ProductoDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: ProductoDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly productoSaved$$ = new Subject<ProductResponse>();

  readonly state = this.state$.asObservable();
  readonly productoSaved$ = this.productoSaved$$.asObservable();

  open(options: ProductoDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(producto: ProductResponse): void {
    this.productoSaved$$.next(producto);
  }
}
